import React, { FC } from 'react';

const GeoLocationIcon: FC = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.35 4.58177V3H12.65V4.58177C16.205 4.88591 19.0546 7.66099 19.3708 11.1663H21V12.4663H19.3708C19.0546 15.9717 16.205 18.7467 12.65 19.0509V21H11.35V19.0509C7.79503 18.7467 4.94543 15.9717 4.62918 12.4663H3V11.1663H4.62918C4.94543 7.66099 7.79503 4.88591 11.35 4.58177ZM11.35 5.88746C8.49668 6.18229 6.24382 8.3963 5.93592 11.1663H8V12.4663H5.93592C6.24382 15.2364 8.49668 17.4504 11.35 17.7452V16H12.65V17.7452C15.5033 17.4504 17.7562 15.2364 18.0641 12.4663H16V11.1663H18.0641C17.7562 8.3963 15.5033 6.18229 12.65 5.88746V8H11.35V5.88746Z"
                fill="currentColor"
            />
            <path
                d="M15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12Z"
                fill="currentColor"
            />
        </svg>
    );
};

export default GeoLocationIcon;
